import "../term/styles.css";

const aboutPage = () => {
  return (
    <div class="about-section">
      {/* <h1>Tentang Kami</h1> */}
      {/* <span class="span-bold">Visi & Misi</span> */}
      <p>
        <b>Kami</b> sebagai pengembang dan penerbit aplikasi DiaryMuslim, dalam
        pengembangannya (terkait mushaf Al–Quran) juga berkonsultasi dengan
        Forum Pelayan Al-Quran ( Yayasan Pelayan Al-Quran Mulia) yang berlokasi
        di Vila Inti Persada Blok A3/21A Pamulang Timur, Tangerang Selatan yang
        dipimpin oleh Bapak H Zarkasi Afif,MA yang juga sebagai Ketua Tim IT
        Lajnah Pentashihan Mushaf Al-Qur'an (LPMQ) Kemenag RI.
      </p>
      <p>
        <b>Visi</b> kami dalam mengembangkan Aplikasi ini untuk mengajak dan
        mengingatkan saudara Muslim untuk selalu menjadikan AlQuran sebagai
        referensi utama dalam hidup
      </p>
      <p>
        <b>Misi</b> kami adalah menghubungkan semua saudara Muslim di dunia
        dengan memberi kemudahan membangun komunitas agar mereka menjadi lebih
        mudah saling mengingatkan, merutinkan membaca, mendengarkan dan berbagi
        motivasi dan inspirasi yang bersumber dari Al-Quran
      </p>
      <span class="span-bold">Informasi Mushaf Al-Quran</span>
      <p>
        Menggunakan Mushaf Standard Indonesia dan Terjemahan Bahasa Indonesia
        Edisi 2019
      </p>
      <span class="span-bold">Kontak Kami</span>
      <p>
        Email: <a href="mailto:admin@diarymuslim.com">admin@diarymuslim.com</a>
      </p>
    </div>
  );
};

export default aboutPage;
